<template>
  <v-card>
    <v-card-title v-if="organization.video" class="title">
      Company video
    </v-card-title>
    <v-alert v-else type="info" color="secondary darken-2" :value="true">
      No video link has been provided.
    </v-alert>
    <v-img v-if="organization.video" class="pb-3">
      <v-layout justify-center>
        <iframe
          :width="$vuetify.breakpoint.mdAndUp ? 560 : 280"
          :height="$vuetify.breakpoint.mdAndUp ? 315 : 158"
          :src="organization.video" allowfullscreen
          frameborder="0" allow="autoplay; encrypted-media"
        />
      </v-layout>
    </v-img>
    <v-card-text v-else>
      No video has been added.
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  computed: mapGetters({ organization: 'client/organization/model' })
}
</script>